exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".jUH3QAM1M-ACTrqCCdIE_{padding:0}._3svjE24-JT3QqlGhxXY1AV{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1.07143rem}._3svjE24-JT3QqlGhxXY1AV._7LGCoj9HhTNJR5bzqIaXC{color:#a4a4a4}._3svjE24-JT3QqlGhxXY1AV,.QUmwBOH0l49Ri3fKgpl1h{padding:.71429rem 1.42857rem}@media only screen and (min-width:640px){._3svjE24-JT3QqlGhxXY1AV,.QUmwBOH0l49Ri3fKgpl1h{padding:.71429rem 2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AcademicInfoGroups_cardContent": "jUH3QAM1M-ACTrqCCdIE_",
	"AcademicInfoGroups_cardContent_info": "_3svjE24-JT3QqlGhxXY1AV",
	"__empty": "_7LGCoj9HhTNJR5bzqIaXC",
	"AcademicInfoGroups_cardContent_badge": "QUmwBOH0l49Ri3fKgpl1h"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/style.postcss
// module id = 2096
// module chunks = 0